import { useSessionStorage } from 'usehooks-ts';

import { IS_MOBILE_APP_USER } from '../constants/mobileApp';

/**
 * True while MyPolicy is running inside the native mobile app webview. The flag
 * is written to session storage by `Layout` when the app opens MyPolicy with
 * `?isMobileAppUser=true`, so it stays set for the rest of the session even
 * after the query param is stripped from the URL.
 */
const useIsMobileAppUser = (): boolean => {
  const [isMobileAppUser] = useSessionStorage(IS_MOBILE_APP_USER, false);

  return isMobileAppUser;
};

export default useIsMobileAppUser;
